import type { FunctionComponent } from 'react';

import styles from './StepHeading.module.less';

// We use (step - 1) to index these.
const descriptions: readonly [string, string] = [
  'Choose the type of customization',
  'Configure your customization',
];

type Props = {
  step: 1 | 2;
};

/**
 * Renders a StepHeading and then renders the children in a section.
 *
 * @param {Props} props - StepHeading props
 * @param {1 | 2} props.step - The step number (1 or 2)
 * @param {ReactNode} props.children - The children to render in the section
 */
export const StepHeading: FunctionComponent<Props> = ({ step, children }) => {
  return (
    <section className={styles.section}>
      <div className={styles.header}>
        <h2 className={styles.heading}>Step {step}</h2>
        <p className={styles.description}>{descriptions[step - 1]}</p>
      </div>
      {children}
    </section>
  );
};
